var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"currency--field-wrap"},[_c('v-text-field',_vm._g(_vm._b({attrs:{"value":_vm.formattedValue,"outlined":"","hide-details":""}},'v-text-field',{ ..._vm.$attrs, ..._vm.$props },false),_vm.listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }